import request from '@/utils/request';

/**
 * 获取config数据
 * @param params
 * @returns {Promise<void>}
 */
export async function getConfig(params) {
  return request('/api/zeyin_school/js/sdk/config', {
    params,
    method: 'GET',
  });
}

export async function getAreaCode(params) {
  return request('/api/zeyin_school/h5/getAreaCode', {
    method: 'GET',
    params,
  })
}
